import _ from "lodash";
import React, { useState, useRef, useEffect } from "react";
import { compose } from "lib/apolloClient";
import { connect } from "react-redux";
import classes from "./MessagesContainer.scss";
import ProfileCascade from "UIComponents/ProfileCascade";
import I18nHOC from "UIComponents/I18nHOC";
import Loading from "UIComponents/Loading";
import { ClockAlarmOutlined } from "@toddle-edu/ds-icons";
import UserAccessPoint, {
  ACCESS_POINT_MODULE,
} from "MessagingV2/components/UserAccessPoint";

import classNames from "classnames";
import DropDown from "../DropDown";
import LECard from "../LECard";
import MessageAttachmentCard from "../MessageAttachmentCard";
import { getTimeSince, getTimeDifferenceIsNow } from "Utils";
import { ClassroomSvg } from "SvgComponents";
import { colors } from "Constants";
import ACLStore from "lib/aclStore";
import { getUserInfo } from "Login/modules/LoginModule/LoginUtils";
import {
  getFormattedUserName,
  getUserIdentifierName,
} from "Utils/GetFormattedUserName";
import { ALERT_TYPES } from "ClassRoom/modules/utils";

const itemStyle = {
  labelStyle: {
    fontSize: "1.4rem",
  },
};

const getCascadeStyle = ({
  isOwnChat,
  showFlatMessage,
  profileIconStyle = {},
}) => {
  return {
    customContainerStyle: {
      marginLeft: showFlatMessage ? "unset" : isOwnChat && 16,
      marginRight: showFlatMessage ? "unset" : !isOwnChat && 16,
      marginTop: showFlatMessage ? "unset" : 12,
      alignItems: "baseline",
    },
    customStyle: {
      width: 32,
      height: 32,
      ...profileIconStyle,
    },
  };
};

const styles = {
  visibilityMessageStyle: {
    margin: "8px 48px 24px",
    borderRadius: "8px",
    height: "48px",
  },
};

const Message = React.memo(props => {
  const {
    message,
    createdBy,
    isRemark = false,
    isOwnChat = false,
    id,
    deleteMessage,
    editMessage,
    itemType,
    item,
    createdAt,
    type,
    t,
    showSenderInfo,
    showMessageTime,
    deleteOtherMessage,
    userType,
    showFlatMessage,
    studentData,
    isTeacherEvaluationEnabled,
    isStudentEvaluationEnabled,
    allowSendMessage,
    attachmentCardType,
    horizontalCardStyle,
    isRightPaneChat,
    mode,
    isClassDiscussionEnabled,
    profileIconStyle,
    senderNameStyle,
    messageWrapperStyle,
    showIsRead,
    isRead,
    showRemarkOption,
    togglePinMessage,
    isPinMessageLoading,
    pinMessages,
    isDeleted,
    messageItemStyle,
    messageSubConStyle,
    attachmentListContainerStyle,
    flatMsgContainerStyle,
    horizontalMessageCardV2,
    dropDownConStyle,
    attachmentListContainerStyleV2,
    renderAlert,
    isEditAndDeleteEnabled,
    showAvatar,
    isAlertTypeMessage,
  } = props;

  const [showDropdown, showHideDropdown] = useState(false);

  const containerClassArray = classNames(
    { [classes.messageItem]: true },
    {
      [classes.ownMsg]: !showFlatMessage && isOwnChat,
    }
  );

  const renderMessage = ({ itemType, type }) => {
    if (type === "SYSTEM_GENERATED_GROUP_CHAT_SECOND") {
      if (isClassDiscussionEnabled && userType === "student") return;
      // family-portal: if class discussion is disabled then message should be shown
      //                else don't show anything
      if (userType === "parent") {
        if (!isClassDiscussionEnabled) {
          return (
            <div
              className={classes.visibilityMessage}
              style={styles.visibilityMessageStyle}
            >
              <div className={classes.iconContainer}>
                <ClassroomSvg fill={colors.black} />
              </div>
              {t("classRoom:teacher_disabled_classdiscussion")}
            </div>
          );
        } else if (isClassDiscussionEnabled) {
          return;
        }
      }

      return renderAlert ? (
        <div className={classes.visibilityMessage}>
          <div className={classes.iconContainer}>
            <ClassroomSvg fill={colors.black} />
          </div>
          {t(
            `classRoom:${
              userType == "student"
                ? allowSendMessage
                  ? "discussion_msg"
                  : "teacher_disabled_classdiscussion"
                : "system_generated_group_chat_msg"
            }`
          )}
        </div>
      ) : null;
    }

    switch (itemType) {
      case "ASSESSMENT":
        return (
          <LECard
            item={item}
            createdAt={createdAt}
            itemStyle={itemStyle}
            isTeacherEvaluationEnabled={isTeacherEvaluationEnabled}
            isStudentEvaluationEnabled={isStudentEvaluationEnabled}
          />
        );
      default:
        return (
          <MessageAttachmentCard
            createdAt={createdAt}
            isRemark={isRemark}
            isOwnChat={isOwnChat}
            message={message}
            itemType={itemType}
            item={item}
            createdBy={createdBy}
            itemStyle={itemStyle}
            showSenderInfo={showSenderInfo}
            showMessageTime={showMessageTime}
            showFlatMessage={showFlatMessage}
            studentData={studentData}
            attachmentCardType={attachmentCardType}
            horizontalCardStyle={horizontalCardStyle}
            isRightPaneChat={isRightPaneChat}
            senderNameStyle={senderNameStyle}
            messageWrapperStyle={messageWrapperStyle}
            showIsRead={showIsRead}
            isRead={isRead}
            showRemarkOption={showRemarkOption}
            togglePinMessage={togglePinMessage}
            isPinMessageLoading={isPinMessageLoading}
            pinMessages={pinMessages}
            userType={userType}
            isDeleted={isDeleted}
            messageSubConStyle={messageSubConStyle}
            attachmentListContainerStyle={attachmentListContainerStyle}
            flatMsgContainerStyle={flatMsgContainerStyle}
            horizontalMessageCardV2={horizontalMessageCardV2}
            attachmentListContainerStyleV2={attachmentListContainerStyleV2}
            isAlertTypeMessage={isAlertTypeMessage}
          />
        );
    }
  };

  const excludeOPtionMsgTypes = [
    "ASSESSMENT",
    "SYSTEM_GENERATED_GROUP_CHAT_SECOND",
    "ASSIGNMENT_RESOURCE",
    "STUDENT_ASSIGNMENT_SUBMISSION",
    "UNHAND_STUDENT_ASSIGNMENT_SUBMISSION",
    "STUDENT_ASSIGNMENT_EVALUATED",
    "STUDENT_ASSIGNMENT_SHARED",
    "STUDENT_ASSIGNMENT_EVALUATED_SHARED",
    ..._.values(ALERT_TYPES),
  ];

  const excludeProfileImgMsgTypes = [
    "SYSTEM_GENERATED_GROUP_CHAT_SECOND",
    ..._.values(ALERT_TYPES),
  ];

  const dropDownContainerStyle = classNames({
    [classes.dropDownContainer]: true,
    [classes.dropDownContainerOpenMode]: showDropdown,
  });

  const messageTimeStampClass = classNames(
    classes.messageTimeStamp,
    "text-body-3"
  );

  const messageTimeStampClassV2 = classNames(
    classes.messageTimeStampV2,
    "text-body-3"
  );

  const messageRightContainerClass = classNames({
    [classes.messageRightContainer]: true,
    [classes.messageRightContainerTimeStamp]:
      isAlertTypeMessage && _.size(message) < 64,
  });
  return (
    <React.Fragment>
      <div className={containerClassArray} style={messageItemStyle}>
        {_.intersection(excludeProfileImgMsgTypes, [itemType, type]).length ==
          0 && (
          <div className={classes.profileCascadeWrapper}>
            {showSenderInfo && (
              <UserAccessPoint
                id={createdBy.id}
                userType={createdBy.type}
                profileImage={createdBy.profileImage}
                name={getUserIdentifierName({ user: createdBy })}
                module={ACCESS_POINT_MODULE.AUTHORIZATION_AND_EVALUATION}
              >
                <ProfileCascade
                  {...getCascadeStyle({
                    isOwnChat,
                    showFlatMessage,
                    profileIconStyle,
                  })}
                  items={[
                    {
                      imageUrl: _.get(createdBy, "profileImage", ""),
                      value: getUserIdentifierName({ user: createdBy }),
                      id,
                    },
                  ]}
                  showAvatar={showAvatar}
                />
              </UserAccessPoint>
            )}
          </div>
        )}
        {isAlertTypeMessage ? (
          <div className={classes.alertIconContainer}>
            <div className={classes.alertIcon}>
              <ClockAlarmOutlined variant="warning" />
            </div>
          </div>
        ) : null}
        {!horizontalMessageCardV2
          ? renderMessage({ itemType, type })
          : !isDeleted &&
            !isAlertTypeMessage && (
              <div className={classes.senderInfo}>
                {(showSenderInfo || isRemark) && (
                  <div className={"text-label-3"} style={senderNameStyle}>
                    {getFormattedUserName({ user: createdBy })}
                  </div>
                )}
                {showFlatMessage && horizontalMessageCardV2 && (
                  <div className={messageTimeStampClassV2}>{createdAt}</div>
                )}
              </div>
            )}
        <div className={messageRightContainerClass}>
          {showFlatMessage && !horizontalMessageCardV2 && (
            <div className={messageTimeStampClass}>{createdAt}</div>
          )}
          {(isOwnChat || deleteOtherMessage) &&
            _.intersection(excludeOPtionMsgTypes, [itemType, type]).length ==
              0 &&
            !_.includes(id, "NEW") &&
            mode == "edit" &&
            !isDeleted &&
            isEditAndDeleteEnabled && (
              <div className={dropDownContainerStyle} style={dropDownConStyle}>
                <DropDown
                  isOwnChat={isOwnChat}
                  deleteOtherMessage={deleteOtherMessage}
                  onUpdateShowDropDown={value => showHideDropdown(value)}
                  onClickDelete={() => deleteMessage(id)}
                  onClickEdit={() => editMessage()}
                  togglePinMessage={togglePinMessage}
                  type={type}
                  showFlatMessage={showFlatMessage}
                />
              </div>
            )}
        </div>
      </div>
      {horizontalMessageCardV2 &&
        renderMessage({ itemType, type, horizontalMessageCardV2 })}
    </React.Fragment>
  );
});

Message.displayName = "Message";

const MessagesContainer = React.memo(props => {
  const {
    conversations,
    userId,
    deleteMessage,
    editMessage,
    containerScroll,
    customItemRef,
    networkStatus,
    setScrollContainerRef,
    showSenderInfoAlways,
    deleteOtherMessage,
    userType,
    showFlatMessage,
    flatMessageConStyle,
    studentData,
    isTeacherEvaluationEnabled,
    isStudentEvaluationEnabled,
    messagesConStyle,
    allowSendMessage,
    messagesScrollStyle,
    t,
    attachmentCardType,
    horizontalCardStyle,
    isRightPaneChat,
    mode = "edit",
    isClassDiscussionEnabled,
    parentType,
    otherUserId,
    showRemarkOption,
    togglePinMessage,
    isPinMessageLoading,
    pinMessages,
    profileIconStyle,
    senderNameStyle,
    messageWrapperStyle,
    customMessageContainerClass,
    messageItemStyle,
    messageSubConStyle,
    attachmentListContainerStyle,
    flatMsgContainerStyle,
    showCommentContextBox,
    messageContextLabel,
    messageContextBoxStyle,
    horizontalMessageCardV2,
    dropDownConStyle,
    attachmentListContainerStyleV2,
    scrollLatestMessage,
    isEditAndDeleteEnabled,
    showAvatar = false,
  } = props;

  const messageContainer = useRef(null);

  const renderAlert = _.isEmpty(
    _.filter(conversations, conversation => {
      return (
        _.get(conversation, "node.type", "") !==
        "SYSTEM_GENERATED_GROUP_CHAT_SECOND"
      );
    })
  );

  useEffect(() => {
    if (messageContainer.current && scrollLatestMessage) {
      messageContainer.current.scrollTop =
        messageContainer.current.scrollHeight +
        messageContainer.current.clientHeight;
    }
    setScrollContainerRef(messageContainer.current);
  }, []);

  const messagesScrolled = () => {
    containerScroll(messageContainer.current);
  };

  const renderLoader = () => {
    return (
      <div className={classes.loaderContainer}>
        <Loading />
      </div>
    );
  };

  return (
    <div
      className={classes.container}
      onScroll={messagesScrolled}
      ref={messageContainer}
      style={messagesConStyle}
    >
      <div className={classes.innerScroll} style={messagesScrollStyle}>
        {showCommentContextBox && (
          <div
            className={classes.commentContextBox}
            style={messageContextBoxStyle}
          >
            <div className={classes.commentLabel}>{messageContextLabel}</div>
          </div>
        )}
        {networkStatus === 3 ? renderLoader() : null}

        {_.map(conversations, (conversation, i) => {
          const conversationNode = conversation.node;
          const isOwnChat =
            userId === _.get(conversationNode, "createdBy.id", "") ||
            otherUserId === _.get(conversationNode, "createdBy.id", "");
          const itemType = _.get(conversationNode, "itemType", "");
          const isDeleted = _.get(conversationNode, "isDeleted", false);
          const conversationsLength = _.get(conversations, "length", 0);
          let showSenderInfo = true;
          let showMessageTime = true;

          const showIsRead =
            parentType == "CHAT" &&
            isOwnChat &&
            ACLStore.can("FeatureFlag:ReadReceiptInFamilyMessaging");

          if (itemType == "STUDENT_ASSIGNMENT_EVALUATED" && !isOwnChat) {
            return;
          }

          if (
            i !== 0 &&
            itemType !== "ASSESSMENT" &&
            itemType !== "ASSIGNMENT_RESOURCE"
          ) {
            const conversationPrevNode = _.get(
              conversations[i - 1],
              "node",
              {}
            );
            if (
              _.isEqual(
                conversationNode.createdBy,
                conversationPrevNode.createdBy
              )
            ) {
              showSenderInfo = !getTimeDifferenceIsNow({
                nowTime: conversationNode.createdAt,
                thenTime: conversationPrevNode.createdAt,
              });
            }
          }
          if (
            i !== conversationsLength - 1 &&
            itemType !== "ASSESSMENT" &&
            itemType !== "ASSIGNMENT_RESOURCE"
          ) {
            const conversationNextNode = _.get(
              conversations[i + 1],
              "node",
              {}
            );
            if (
              _.isEqual(
                conversationNextNode.createdBy,
                conversationNode.createdBy
              ) &&
              _.isEqual(conversationNextNode.type, conversationNode.type)
            ) {
              showMessageTime = !getTimeDifferenceIsNow({
                nowTime: conversationNextNode.createdAt,
                thenTime: conversationNode.createdAt,
              });
            }
          }

          // showSenderInfo always if showSenderInfoAlways is true
          showSenderInfo = showSenderInfoAlways || showSenderInfo;

          // if flat messages true then display sender info always and do not display message time
          if (showFlatMessage) {
            showSenderInfo = true;
            showMessageTime = false;
          }

          const isRemark = _.isEqual(
            "REMARK",
            _.get(conversationNode, "type", "")
          );

          const isAlertTypeMessage = _.includes(
            _.values(ALERT_TYPES),
            itemType
          );

          const messageContainerClass = classNames({
            [classes.messageContainer]: true,
            [classes.flatMessageCon]: showFlatMessage,
            [classes.remarkBackground]:
              isRemark && showFlatMessage && showRemarkOption,
            [customMessageContainerClass]: !!customMessageContainerClass,
            [classes.alert]: userType === "staff" && isAlertTypeMessage,
          });

          return (
            <div
              key={conversationNode.id}
              className={messageContainerClass}
              ref={ref => customItemRef(ref, i, conversationNode.id)}
              style={{
                marginTop: showFlatMessage
                  ? 0
                  : itemType == "ASSESSMENT" ||
                    (itemType == "ASSIGNMENT_RESOURCE"
                      ? "32px"
                      : !showSenderInfo && 0),
                marginBottom: showFlatMessage ? 0 : !showMessageTime && "4px",
                ...flatMessageConStyle,
              }}
            >
              <Message
                id={conversationNode.id}
                isRemark={isRemark}
                isOwnChat={isOwnChat}
                createdBy={conversationNode.createdBy}
                itemType={itemType}
                type={conversationNode.type}
                createdAt={getTimeSince(
                  new Date(conversationNode.createdAt),
                  t
                )}
                message={conversationNode.label}
                item={conversationNode.item}
                deleteMessage={deleteMessage}
                editMessage={() => editMessage(conversationNode)}
                showSenderInfo={showSenderInfo}
                showMessageTime={showMessageTime}
                deleteOtherMessage={deleteOtherMessage}
                userType={userType}
                showFlatMessage={showFlatMessage}
                studentData={studentData}
                isTeacherEvaluationEnabled={isTeacherEvaluationEnabled}
                isStudentEvaluationEnabled={isStudentEvaluationEnabled}
                allowSendMessage={allowSendMessage}
                attachmentCardType={attachmentCardType}
                horizontalCardStyle={horizontalCardStyle}
                isRightPaneChat={isRightPaneChat}
                mode={mode}
                isClassDiscussionEnabled={isClassDiscussionEnabled}
                profileIconStyle={profileIconStyle}
                senderNameStyle={senderNameStyle}
                messageWrapperStyle={messageWrapperStyle}
                t={t}
                showIsRead={showIsRead}
                isRead={conversationNode.isRead}
                showRemarkOption={showRemarkOption}
                togglePinMessage={() => togglePinMessage(conversationNode)}
                isPinMessageLoading={isPinMessageLoading}
                pinMessages={pinMessages}
                isDeleted={isDeleted}
                messageItemStyle={messageItemStyle}
                messageSubConStyle={messageSubConStyle}
                attachmentListContainerStyle={attachmentListContainerStyle}
                flatMsgContainerStyle={flatMsgContainerStyle}
                horizontalMessageCardV2={horizontalMessageCardV2}
                dropDownConStyle={dropDownConStyle}
                attachmentListContainerStyleV2={attachmentListContainerStyleV2}
                renderAlert={renderAlert}
                isEditAndDeleteEnabled={isEditAndDeleteEnabled}
                showAvatar={showAvatar}
                isAlertTypeMessage={isAlertTypeMessage}
              />
            </div>
          );
        })}
      </div>
    </div>
  );
});

MessagesContainer.displayName = "MessagesContainer";

const mapStateToProps = () => {
  const userInfo = getUserInfo();
  return {
    userType: userInfo.user_type,
  };
};

export default compose(
  connect(mapStateToProps),
  I18nHOC({ resource: ["common", "classRoom"] })
)(MessagesContainer);
